import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { OrganizationService } from '../../../areas/organization/organization.service';
import { InvitationTokenDto, InvitationTokenDetails } from '../../../_models/organization/organization';
import { PersistenceService } from '../../../_services/persistence.service';
import { BaseComponent } from '@app/base/basecomponent';


@Component({
  selector: 'accept-org-invitation',
  templateUrl: './accept-org-invitation.component.html',
  styleUrls: ['./accept-org-invitation.component.scss']
})
export class AcceptOrgInvitationComponent extends BaseComponent implements OnInit {

  public loading: boolean = true;

  private token: string;

  public validToken: boolean;
  private expiredToken: boolean;          // For now unused
  private alreadyAcceptedToken: boolean;  // For now unused

  public actionCompleted: boolean = false;

  public details: InvitationTokenDetails;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private organizationService: OrganizationService,
    private persistenceService: PersistenceService,
  ) {
    super();

    this.activatedRoute.queryParams.subscribe(params => {
      this.token = params['token'];

      var lang = params['lang'];
      if (!lang) {
        lang = 'fi';
      }
      this.persistenceService.setLang(lang);
    });
  }

  ngOnInit() {
    if (!this.token) {
      this.validToken = false;
      return;
    }

    this.validateInvitationToken();
  }

  validateInvitationToken() {
    var dto = new InvitationTokenDto();
    dto.token = this.token;
    this.subscription.add(
      forkJoin(
        this.organizationService.validateInvitationToken(dto),
      ).subscribe(([data]) => {
        if (data.validity == "valid") {
          this.validToken = true;
          this.details = data.details;
        }
        else {
          this.validToken = false;
        }
        if (data.validity == "expired") {
          this.expiredToken = true;
        }
        else if (data.validity == "accepted") {
          this.alreadyAcceptedToken = true;
        }
      }, error => {
        this.loading = false;
        this.alertService.error(this.translate.instant("organization.errors.invalid_token"));
      }, () => {
        this.loading = false;
      })
    )
  }

  acceptInvitation() {
    var dto = new InvitationTokenDto();
    dto.token = this.token;
    this.organizationService.acceptInvitation(dto).subscribe((result) => {
      this.actionCompleted = true;
    }, error => {
      this.alertService.error(this.translate.instant("organization.errors.invalid_token"));
    });
  }

  goToLoginPage() {
    this.router.navigate(['./login']);
  }
}
